import { Toaster } from '@/components/ui/toast'

// export const toaster = Toast.createToaster({
//   placement: 'bottom-end',
//   overlap: true,
//   gap: 16,
// })

export default function () {
  return (
    <Toaster>
      {/* {(toast) => (
          <Toast.Root
            borderColor={toast().type}
            borderWidth="1px"
            border="solid"
          >
            <Flex
              justifyContent="start"
              alignItems="center"
              gap={2}
              mb={2}
            >
              <Switch>
                <Match when={toast().type === 'error'}>
                  <AlertTriangle
                    class={css({
                      color: 'error',
                    })}
                    size={20}
                  />
                </Match>
                <Match when={toast().type === 'success'}>
                  <Check
                    class={css({
                      color: 'success',
                    })}
                    size={20}
                  />
                </Match>
                <Match when={toast().type === 'info'}>
                  <Lightbulb
                    class={css({
                      color: 'info',
                    })}
                    size={20}
                  />
                </Match>
              </Switch>
              <Toast.Title>{toast().title}</Toast.Title>
            </Flex>
            <Toast.Description>{toast().description}</Toast.Description>
            <Show when={toast().action}>
              <Toast.ActionTrigger
                asChild={(actionProps) => (
                  <Button
                    {...actionProps()}
                    variant="plain"
                    size="sm"
                  >
                    Action
                  </Button>
                )}
              />
            </Show>
            <Toast.CloseTrigger
              asChild={(closeProps) => (
                <IconButton
                  {...closeProps()}
                  size="sm"
                  variant="plain"
                >
                  <XIcon />
                </IconButton>
              )}
            />
          </Toast.Root>
        )} */}
    </Toaster >
  )
}
